import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@app/../environments/environment";
import { Observable } from "rxjs";

@Injectable()
export class RalinkDatabaseService {
    private ralinkUrl: string;

    constructor(private readonly http: HttpClient) {
        this.ralinkUrl = environment.ralinkUrl;
    }

    public getClareSystem$(body: string[]): Observable<any> {
        return this.http.post(this.ralinkUrl + ":8082/stats/onlineConnCheck", body);
    }
}
